import tempMeeApi from '../../../apis/tempMee';

export const CAMPAIGNS_ENDPOINT = '/campaign-service/v1/admin/campaigns';

/**
 * Hard server-side cap on `limit` — campaign-service clamps anything larger
 * rather than erroring, so a caller asking for more truncates silently.
 */
export const CAMPAIGNS_MAX_LIMIT = 100;

/**
 * One page of campaigns: `GET /v1/admin/campaigns` on campaign-service.
 *
 * Newest first, server-side. Filters are lifecycle-level (`status` is
 * draft/active/paused/closing/ended, `mechanismType` discount/incentive,
 * `identityType` office/professional) and are omitted when falsy — the
 * service answers an unknown or empty filter value with a 400, not an empty
 * page.
 *
 * @param {Object} [params]
 * @param {number} [params.page=1] - 1-based page.
 * @param {number} [params.limit=CAMPAIGNS_MAX_LIMIT] - Page size, capped at 100.
 * @param {string} [params.status] - Lifecycle status filter.
 * @param {string} [params.mechanismType] - discount | incentive.
 * @param {string} [params.identityType] - office | professional.
 */
export const getCampaigns = async ({
  page = 1,
  limit = CAMPAIGNS_MAX_LIMIT,
  status,
  mechanismType,
  identityType,
} = {}) => {
  const params = { page, limit };
  if (status) params.status = status;
  if (mechanismType) params.mechanismType = mechanismType;
  if (identityType) params.identityType = identityType;

  const response = await tempMeeApi.get(CAMPAIGNS_ENDPOINT, { params });

  return response.data;
};
